import React, { Component } from 'react'
import { graphql } from 'gatsby'
import Slider from 'react-slick'

import SEO from "../components/seo"

class Product extends Component {

  state = {
    variant: this.props.data.shopifyProduct.variants[0],
    price: this.props.data.shopifyProduct.variants[0].price,
  }

  _selectVariant = (variant) => () => {
    this.setState({ 
      variant, 
      price: variant.price
    })
  }

  _addToCart = () => {
    let { variant } = this.state
    this.props.addVariantToCart(variant.shopifyId, 1)
  }

  render() {
    const product = this.props.data.shopifyProduct

    let { variant, price } = this.state

    const settings = {
      infinite: true,
      speed: 600,
      fade:true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      cssEase: 'ease',
      pauseOnHover: false,
      focusOnSelect: false,
    }

    return (
      <>
        <SEO title={`${product.title} - Emily Gillis`} bodyClass='single-product' description={product.description} />
        <article className="single-product__wrapper">
          <div className='single-product__inner'>
            <section className='single-product__gallery'>
              { product.media.length > 0 &&
                <Slider {...settings}>
                  { product.media.map((el, i) => <img key={i} src={el.image.originalSrc} alt={product.title} />) }
                </Slider>
              }
            </section>
            <section className='single-product__info'>
              <h1>{product.title}</h1>
              <span className='single-product__price'>${parseFloat(price).toFixed(2)}</span>
              { product.variants.length > 1 &&
                <div className='single-product__variations'>
                  { product.variants.map((el, i) => {
                    let props = {
                      key: i,
                      className: `btn--variation ${el.shopifyId === variant.shopifyId ? 'active' : ''}`,
                      onClick: this._selectVariant(el),
                    }
                    return (<button {...props}>{ el.title }</button>)
                  }) }
                </div>
              }
              { variant.inventoryQuantity > 0 && <button className='btn--cart btn' onClick={this._addToCart}>Add to cart</button> }
              { variant.inventoryQuantity < 1 && <button className='btn--cart btn' disabled>Sold Out</button> }
              <div className='single-product__description' dangerouslySetInnerHTML={{ __html: product.descriptionHtml }} />
            </section>
          </div>
        </article>
      </>
    )
  }

}

export default Product

export const productQuery = graphql`
  query ShopifyProductById($id: String!) {
    shopifyProduct(id: { eq: $id }) {
      id
      shopifyId
      title
      description
      descriptionHtml
      handle
      media {
        ... on ShopifyMediaImage {
          image {
            originalSrc
          }
        }
      }
      variants {
        title
        shopifyId
        price
        inventoryQuantity
        image {
          originalSrc
          width
          height
        }
      }
    }
  }
`
